export default __webpack_public_path__ + "static/media/icon-emptynotification.85978c9b.svg";